// Country and State/Province data for address forms

export const COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'MX', name: 'Mexico' },
  // EU27 Countries
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'DE', name: 'Germany' },
  { code: 'GR', name: 'Greece' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IT', name: 'Italy' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MT', name: 'Malta' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Romania' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ES', name: 'Spain' },
  { code: 'SE', name: 'Sweden' }
];

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming'
];

export const CANADIAN_PROVINCES = [
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
  'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',
  'Quebec', 'Saskatchewan', 'Yukon'
];

export const MEXICAN_STATES = [
  'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche', 'Chiapas',
  'Chihuahua', 'Coahuila', 'Colima', 'Durango', 'Guanajuato', 'Guerrero', 'Hidalgo',
  'Jalisco', 'México', 'Mexico City', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León',
  'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa',
  'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
];

export const EU_REGIONS = {
  'AT': ['Burgenland', 'Carinthia', 'Lower Austria', 'Salzburg', 'Styria', 'Tyrol', 'Upper Austria', 'Vienna', 'Vorarlberg'],
  'BE': ['Brussels', 'Flanders', 'Wallonia'],
  'BG': ['Sofia', 'Plovdiv', 'Varna', 'Burgas', 'Ruse', 'Pleven'],
  'HR': ['Zagreb', 'Split-Dalmatia', 'Primorje-Gorski Kotar', 'Istria', 'Osijek-Baranja'],
  'CY': ['Nicosia', 'Limassol', 'Larnaca', 'Paphos', 'Famagusta'],
  'CZ': ['Prague', 'Central Bohemian', 'South Bohemian', 'Plzeň', 'Karlovy Vary', 'Ústí nad Labem', 'Liberec', 'Hradec Králové', 'Pardubice', 'Vysočina', 'South Moravian', 'Olomouc', 'Zlín', 'Moravian-Silesian'],
  'DK': ['Capital', 'Zealand', 'Southern Denmark', 'Central Denmark', 'North Denmark'],
  'EE': ['Harju', 'Tartu', 'Ida-Viru', 'Pärnu', 'Lääne-Viru'],
  'FI': ['Lapland', 'North Ostrobothnia', 'Kainuu', 'North Karelia', 'Northern Savonia', 'Southern Savonia', 'South Karelia', 'Päijänne Tavastia', 'Kymenlaakso', 'South Ostrobothnia', 'Ostrobothnia', 'Central Ostrobothnia', 'Central Finland', 'Pirkanmaa', 'Satakunta', 'Tavastia Proper', 'Uusimaa', 'Southwest Finland', 'Åland'],
  'FR': ['Île-de-France', 'Auvergne-Rhône-Alpes', 'Nouvelle-Aquitaine', 'Occitanie', 'Provence-Alpes-Côte d\'Azur', 'Pays de la Loire', 'Brittany', 'Normandy', 'Centre-Val de Loire', 'Bourgogne-Franche-Comté', 'Grand Est', 'Hauts-de-France', 'Corsica'],
  'DE': ['Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hesse', 'Lower Saxony', 'Mecklenburg-Vorpommern', 'North Rhine-Westphalia', 'Rhineland-Palatinate', 'Saarland', 'Saxony', 'Saxony-Anhalt', 'Schleswig-Holstein', 'Thuringia'],
  'GR': ['Attica', 'Central Macedonia', 'Central Greece', 'Crete', 'East Macedonia and Thrace', 'Epirus', 'Ionian Islands', 'North Aegean', 'Peloponnese', 'South Aegean', 'Thessaly', 'West Greece', 'West Macedonia'],
  'HU': ['Budapest', 'Pest', 'Fejér', 'Komárom-Esztergom', 'Veszprém', 'Győr-Moson-Sopron', 'Vas', 'Zala', 'Baranya', 'Somogy', 'Tolna', 'Borsod-Abaúj-Zemplén', 'Heves', 'Nógrád', 'Hajdú-Bihar', 'Jász-Nagykun-Szolnok', 'Szabolcs-Szatmár-Bereg', 'Bács-Kiskun', 'Békés', 'Csongrád-Csanád'],
  'IE': ['Dublin', 'Cork', 'Galway', 'Limerick', 'Waterford', 'Louth', 'Meath', 'Wicklow', 'Kildare', 'Kerry', 'Clare', 'Tipperary', 'Kilkenny', 'Wexford', 'Donegal', 'Mayo', 'Sligo', 'Leitrim', 'Roscommon', 'Cavan', 'Monaghan', 'Westmeath', 'Longford', 'Offaly', 'Laois', 'Carlow'],
  'IT': ['Abruzzo', 'Aosta Valley', 'Apulia', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardy', 'Marche', 'Molise', 'Piedmont', 'Sardinia', 'Sicily', 'Tuscany', 'Trentino-South Tyrol', 'Umbria', 'Veneto'],
  'LV': ['Riga', 'Daugavpils', 'Liepāja', 'Jelgava', 'Jūrmala'],
  'LT': ['Vilnius', 'Kaunas', 'Klaipėda', 'Šiauliai', 'Panevėžys'],
  'LU': ['Luxembourg', 'Diekirch', 'Grevenmacher'],
  'MT': ['Malta', 'Gozo'],
  'NL': ['North Holland', 'South Holland', 'Utrecht', 'North Brabant', 'Gelderland', 'Overijssel', 'Limburg', 'Friesland', 'Groningen', 'Drenthe', 'Flevoland', 'Zeeland'],
  'PL': ['Masovian', 'Lesser Poland', 'Greater Poland', 'Silesian', 'Pomeranian', 'Lower Silesian', 'West Pomeranian', 'Łódź', 'Kuyavian-Pomeranian', 'Lublin', 'Subcarpathian', 'Warmian-Masurian', 'Podlaskie', 'Świętokrzyskie', 'Lubusz', 'Opole'],
  'PT': ['Lisbon', 'Porto', 'Faro', 'Setúbal', 'Aveiro', 'Braga', 'Coimbra', 'Évora', 'Beja', 'Castelo Branco', 'Guarda', 'Leiria', 'Santarém', 'Viana do Castelo', 'Vila Real', 'Viseu', 'Bragança', 'Portalegre', 'Madeira', 'Azores'],
  'RO': ['Bucharest', 'Cluj', 'Timiș', 'Iași', 'Constanța', 'Brașov', 'Dolj', 'Prahova', 'Galați', 'Argeș'],
  'SK': ['Bratislava', 'Trnava', 'Trenčín', 'Nitra', 'Žilina', 'Banská Bystrica', 'Prešov', 'Košice'],
  'SI': ['Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Velenje'],
  'ES': ['Andalusia', 'Aragon', 'Asturias', 'Balearic Islands', 'Basque Country', 'Canary Islands', 'Cantabria', 'Castile and León', 'Castile-La Mancha', 'Catalonia', 'Extremadura', 'Galicia', 'La Rioja', 'Madrid', 'Murcia', 'Navarre', 'Valencia'],
  'SE': ['Stockholm', 'Västra Götaland', 'Skåne', 'Östergötland', 'Uppsala', 'Södermanland', 'Jönköping', 'Halland', 'Örebro', 'Gävleborg', 'Västernorrland', 'Dalarna', 'Västmanland', 'Kronoberg', 'Kalmar', 'Gotland', 'Blekinge', 'Värmland', 'Jämtland', 'Norrbotten', 'Västerbotten']
};

export const getStatesForCountry = (countryCode) => {
  switch (countryCode) {
    case 'US':
      return US_STATES;
    case 'CA':
      return CANADIAN_PROVINCES;
    case 'MX':
      return MEXICAN_STATES;
    default:
      // EU countries
      return EU_REGIONS[countryCode] || [];
  }
};

export const getPostalCodeLabel = (countryCode) => {
  switch (countryCode) {
    case 'US':
      return 'ZIP Code';
    case 'CA':
      return 'Postal Code';
    case 'MX':
      return 'Código Postal';
    default:
      return 'Postal Code';
  }
};

export const getStateLabel = (countryCode) => {
  switch (countryCode) {
    case 'US':
      return 'State';
    case 'CA':
      return 'Province';
    case 'MX':
      return 'Estado';
    default:
      return 'Region/State';
  }
};
